import { create } from 'zustand';

export type Role = 'owner' | 'admin' | 'teacher' | 'parent' | 'student';

export interface EffectivePermission {
  obj: string;
  act: string;
}

export interface CurrentUser {
  id: string;
  login: string;
  full_name: string;
  role: Role;
  force_password_change: boolean;
  avatar_file_id?: string | null;
  avatar_url?: string | null;
  permissions: EffectivePermission[];
}

interface AuthState {
  /** Access token is kept in memory only (not localStorage) - see context.md 3.2. */
  accessToken: string | null;
  user: CurrentUser | null;
  /** Changes whenever the authenticated identity is replaced or cleared. */
  generation: number;
  setSession: (accessToken: string, user: CurrentUser) => void;
  setAccessToken: (accessToken: string) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  generation: 0,
  setSession: (accessToken, user) =>
    set((state) => ({
      accessToken,
      user,
      generation: state.generation + (state.user?.id === user.id ? 0 : 1),
    })),
  setAccessToken: (accessToken) => set({ accessToken }),
  clear: () =>
    set((state) => ({ accessToken: null, user: null, generation: state.generation + 1 })),
}));
